import { render } from "./BackPage.vue?vue&type=template&id=b2d5d552"
import script from "./BackPage.vue?vue&type=script&lang=js"
export * from "./BackPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__